







































import { Vue, Component, Prop, Watch, Model, Emit } from 'vue-property-decorator';
import TagSearchAppend from '@/views/reports/pickers/tag-search-append.vue';
import TagApi from '@/services/rest/bemob/tag';

@Component({  
  components: {
    TagSearchAppend
  }
})
export default class TagSearchSelect extends Vue {
  tagApi: TagApi = new TagApi();
  
  @Prop()
  hideTags: boolean;
  
  @Prop()
  isShowClear: boolean;
  
  @Prop()
  hasMarks: boolean;
  
  @Prop()
  searchTags: string;
  
  @Prop()
  switchSearchMode: string;

  @Model('change')
  modelValue: any

  @Prop()
  value: any;

  get selected() {
    return this.switchSearchMode
  }

  get tagsList() {
    return this.$store.state.cache.tags[this.$route.params.type]?.data?.map(item=>item.name) || []
  }

  set selected(value: string) {
    this.$emit('update:switchSearchMode', value);
  }
  
  get tags() {
    return this.modelValue
  }

  set tags(value) {
    this.$emit('change', value)
  }
  
  @Watch('$route.params.type', {
    immediate: true
  })
  async onRouteParamsTypeChanges(val: string) {
    switch(val) {
      case 'campaigns':
      case 'offers':
      case 'flows':
      case 'landings':
      case 'traffic-sources':
      case 'affiliate-networks':
      if(!this.$store.state.cache.tags[val].isUploaded){
        await this.tagApi.populateStoreCache({type:val})
      }
    }
  }
  
}
